import { TextField, Theme } from '@mui/material';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

export const PlanDescriptionField = () => {
  const { control, getValues } = useFormContext();
  const { t } = useTranslation();
  const ptoPlanFullDescription = 'ptoPlanFullDescription';

  const useStyles = makeStyles()((theme: Theme) => ({
    textField: {
      '& .MuiFilledInput-root': {
        backgroundColor: 'rgba(0,0,0,0.04)',
      },
      '& .MuiFilledInput-root:hover': {
        backgroundColor: 'rgba(0,0,0,0.04)',
        '@media (hover: none)': {
          backgroundColor: 'rgba(0,0,0,0.04)',
        },
      },
      '& .MuiFilledInput-root.Mui-disabled': {
        backgroundColor: 'rgba(0,0,0,0.04)',
      },
      '& .MuiFilledInput-root.Mui-disabled:before': {
        borderBottomStyle: 'solid',
      },
      '& .MuiFilledInput-root:hover.Mui-disabled:before': {
        borderBottom: '1px solid gray !important',
      },
      '& .MuiFilledInput-input': {
        cursor: 'default',
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <Controller
      control={control}
      name={ptoPlanFullDescription}
      rules={{
        maxLength: { value: 225, message: 'notification.createTask.maxLimitLabel' },
      }}
      render={({ field: { onChange, ...rest } }) => (
        <TextField
          multiline
          className={classes.textField}
          fullWidth
          maxRows={5}
          variant="filled"
          color="primary"
          autoComplete="off"
          label={t('placement.placementMods.ptoPlanDesc')}
          InputLabelProps={{
            shrink: getValues(ptoPlanFullDescription) ? true : false,
          }}
          inputProps={{
            readOnly: true,
          }}
          value={getValues(ptoPlanFullDescription)}
          required={false}
          onChange={e => {}}
        />
      )}
    />
  );
};
